module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "id": "responsive"
    }
  }, [_c('h1', [_vm._v("Bienvenue sur le site de découverte de l'Anthologie Palatine")]), _vm._v(" "), _c('p', [_vm._v("Malheuresement, ce site ne peut pas être visionné sur mobile et tablette")]), _vm._v(" "), _c('p', [_vm._v("Veuillez utiliser un ordinateur pour accéder à ce site")]), _vm._v(" "), _c('p', [_vm._v("Merci et à bientôt !")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f51b701"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResponsiveComponent.vue
// module id = 106
// module chunks = 0